module.exports = __webpack_public_path__ + "img/pin-emerald.86222d62.png";